import React, { useEffect } from 'react';

import {
  MenuEmptyStateContainer,
  MenuEmptyStateImageWrapper,
  MenuEmptyStateMessage,
  MenuEmptyStateTitle,
} from 'features/menu/pages/main-menu-page/menu-empty-state/styled';

import { PullToReloadScrollView } from 'components/pull-to-reload/pull-to-reload';
import { DestructuredBurgerSvg } from 'components/svgs/destructured-burger';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { useIsDesktopBreakpoint, useIsMobileBreakpoint } from 'hooks/use-media-query';
import { CustomEventNames, EventTypes, logRBIEvent } from 'state/amplitude';
import { t } from 'state/intl/translations';

type MenuEmptyStateProps = {
  logWhenTrue?: boolean;
  logContext?: Record<string, unknown>;
  onRefresh: () => Promise<void>;
};

export const MenuEmptyState = ({
  logWhenTrue = false,
  logContext,
  onRefresh,
}: MenuEmptyStateProps) => {
  const isMobile = useIsMobileBreakpoint();
  const title = t('menuEmptyScreenTitle');
  const message = isMobile ? t('menuEmptyScreenMessage') : t('menuEmptyScreenDesktopMessage');

  const isDesktop = useIsDesktopBreakpoint();

  // this is for analytics purposes - runs once per screen view
  useEffect(() => {
    if (logWhenTrue) {
      logRBIEvent({
        name: CustomEventNames.EMPTY_MENU_SCREEN,
        type: EventTypes.Other,
      });
    }
  }, [logWhenTrue]);

  // this is for error tracking purposes
  useLogUserErrorMessage({
    logWhenTrue,
    message: 'Menu data is empty, displaying empty state',
    severity: LogUserErrorSeverity.Recoverable,
    context: logContext,
  });

  return (
    <PullToReloadScrollView onRefresh={onRefresh} progressViewOffset={10} isDisabled={isDesktop}>
      <MenuEmptyStateContainer>
        <MenuEmptyStateImageWrapper>
          <DestructuredBurgerSvg width={'full'} />
        </MenuEmptyStateImageWrapper>
        <MenuEmptyStateTitle>{title}</MenuEmptyStateTitle>
        <MenuEmptyStateMessage>{message}</MenuEmptyStateMessage>
      </MenuEmptyStateContainer>
    </PullToReloadScrollView>
  );
};
